import React, { Component } from "react";
import { Grid, WithStyles, withStyles, createStyles } from "@material-ui/core";

const styles = () =>
  createStyles({
    inputContainer: {
      borderRadius: 4,
      border: "1px solid #dfdfdf",
      padding: "12px 16px",
      width: "100%",
      height: 40,
      lineHeight: "14px",
      position: "relative",
    },
    plusIcon: {
      position: "absolute",
      right: 4,
      cursor: "pointer",
      top: 10,
      zIndex: 9,
    },
    placeholderTxt: {
      color: "#999",
      fontSize: 13,
    },
    AddedText: {
      fontSize: 14,
      color: "#666",
      fontWeight: 600,
    },
    EditLink: {
      color: "#1d7dea",
      fontSize: 14,
      lineHeight: "15px",
      textDecoracion: "underline",
      top: 12,
      zIndex: 9,
    },
  });

interface Props extends WithStyles<typeof styles> {
  placeholder?: string;
  value?: string | any[];
  handleAddOrEdit: () => void;
  renderer: (value: any) => void;
  disabled?: boolean;
}

class InputViaDialog extends Component<Props> {
  renderer = () => {
    const { placeholder = "Select", value, classes, renderer } = this.props;
    if (!value || value.length === 0) {
      return <Grid item><span className={[classes.placeholderTxt, "Font14"].join(' ')}>{placeholder}</span></Grid>;
    }
    if (renderer) {
      return renderer(value);
    }
    const valueToRender = typeof value === "string" ? value : value.join(", ");
    return <Grid item><span className={[classes.AddedText, "lineHeight28"].join(' ')}>{valueToRender}</span></Grid>;
  };

  renderCTA = () => {
    const { value, classes, handleAddOrEdit, disabled } = this.props;
    if(disabled) {
      return null;
    }
    if (!value || value.length === 0) {
      return (
        <span className={classes.plusIcon} onClick={handleAddOrEdit}>
          <img src="/assets/svg/contentRequest/plusSign.svg" alt="add cta" />
        </span>
      );
    }
    return (
      <span
        className={[classes.AddedText, classes.plusIcon, classes.EditLink].join(
          " "
        )}
        onClick={handleAddOrEdit}
      >
        Edit{" "}
      </span>
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <Grid className={classes.inputContainer} container justify="space-between" alignItems="center">
        {this.renderer()}
        <Grid item>{this.renderCTA()}</Grid>
      </Grid>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(InputViaDialog);
